import React from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import './RoomCard.css';

function RoomCard(props) {

    const height = window.innerHeight;
    const width = window.innerWidth;
   
   
    return (
        <Card  style={{border:'none'}}>
            <div >
                <div className='zoomInOut'>
                    <img   src={props.name} className='cardImage ' alt='pic' />
                    
                </div>
                
                {/* <Link style={{textDecoration:'none'}}  to={width <= 992?props.dest:props.dest2}>
                    <p className='title1'>{props.title}</p>
                </Link> */}
                <NavLink style={{textDecoration:'none'}}  to={width <= 992?props.dest:props.dest2}>
                    <p className='title1'>{props.title}</p>
                </NavLink>
                
            </div>
            
        </Card>
    )
}

export default RoomCard
